export enum DeclinationEmailDialogFormLabelsEnum {
  TITLE = 'Declination Email',
  SEND = 'Send',
  SKIP = 'Skip',
  CANCEL = 'Cancel',
}
